import { render, staticRenderFns } from "./base-swiper.vue?vue&type=template&id=164188f7&scoped=true&"
import script from "./base-swiper.vue?vue&type=script&lang=js&"
export * from "./base-swiper.vue?vue&type=script&lang=js&"
import style0 from "./base-swiper.vue?vue&type=style&index=0&id=164188f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164188f7",
  null
  
)

export default component.exports